import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";

import { environment } from '../../../Context/environment';

import { commonMessage, statusCodes } from "../../../Constants/generalConfig";
import {
  branchListApi,
  clientListApi,
  currency,
  downloadBill,
  getInvoiceList,
  gstGenerateInvoice,
  gstPreviewInvoiceAPI,
  logOutApi,
  multipleServicesListApi,
  offerListInvoiceAPI,
  qrCodeApi,
  resendInvoice,
  staffListApi,
} from "../../../Context/api";

const useBillInvoice = () => {
  const userData = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("userData"));
    } catch {
      return null;
    }
  }, []);

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [spinner, setSpinner] = useState(false);
  const [serviceList, setServiceList] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [teamMember, setTeamMember] = useState([]);
  // const [offerList, setOfferList] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  const [previewInvoiceList, setpreviewInvoiceList] = useState([]);
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  const PER_PAGE = 10;
  const [errors, setErrors] = useState({});
  const [invoiceMod, setInvoiceMod] = useState(false)
  const [selectedInvoice, setSelectedInvoice] = useState(null); // store clicked row
  const [resendLoading, setResendLoading] = useState(false);
  const [resendSendType, setResendSendType] = useState([]);
     const [qrCodeData, setQrCodeData] = useState('')
const [offerMap, setOfferMap] = useState({});
    const [currencyName, setCurrencyName] = useState([])
const [searchFilter, setSearchFilter] = useState({
   startDate: null,
   endDate: null,
   clientId:null,
   searchText:null,
   staffId:null,
   branchId:null,
})

 const [applyFilterKey, setApplyFilterKey] = useState(0);

const handleOpenInvoiceModal = (invoice) => {
  setSelectedInvoice(invoice);
  setInvoiceMod(true);
};

const handleCloseInvoiceModal = () => {
  setInvoiceMod(false);
  setSelectedInvoice(null); // optional but recommended
};

  // helpers to read sendType array
const isSendSelected = (type) => {
  return (selectedInvoice?.sendType || []).some((x) => x.type === type && x.isSelected);
};


const selectedEmail =
  (selectedInvoice?.sendType || []).find((x) => x.type === "EMAIL")?.email || "-";

  const visitType = [
    { name: "INOFFICE", id: "INOFFICE" },
    { name: "HOME", id: "HOME" },
    { name: "ONLINE", id: "ONLINE" },
  ];

  const defaultSendTypes = () => [
    { type: "EMAIL", email: null, isSelected: false },
    { type: "WHATSAPP", email: null, isSelected: false },
    { type: "SMS", email: null, isSelected: false },
  ];


    const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setSearchFilter((prev) => ({ ...prev, [name]: value }));
    
  };

  // user clicks Search => reset page to 1 and trigger refetch
  const applySearchFilter = () => {
    setPage(1);
    setApplyFilterKey((k) => k + 1);
  };

  // reset filter + refresh list
  const resetSearchFilter = () => {
    setSearchFilter({
      startDateTime: "",
      endDateTime: "",
      clientId: "",
      searchText: "",
      staffId:'',
      branchId:'',
    });
    setPage(1);
    setApplyFilterKey((k) => k + 1);
  }

  const [formData, setFormData] = useState({
    startDateTime: "",
    endDateTime: "",
    timezone: timeZone,
    branchId: null,
    services: [],
    subTotal: 0,
    totalGst: 0,
    totalAmount: 0,
    createdby_id: userData?.userId || "",
    clientId: null,
    providerId: userData?.providerId || "",
    visitType: "",

    // NEW: array
    sendType: defaultSendTypes(),

    clientName: null,
    mobileNo: null,
    additionalOffer:{
      discountPrice: 0,
      discount:0,
      discountType:null,
    },
    paymentMode:null,
    paymentType:null
  });

  const logOutFun = () => {
    if (!userData?.token) return;
    axios
      .post(
        logOutApi(),
        { deviceId: userData.deviceId, userId: userData?.userId, type: "WEBPROVIDER" },
        { headers: { Authorization: `Bearer ${userData?.token}` } }
      )
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          localStorage.removeItem("userData");
          window.location.href = "/";
        }
      })
      .catch(() => {});
  };

  const clearError = (name) => {
    setErrors((prev) => {
      if (!prev?.[name]) return prev;
      const copy = { ...prev };
      delete copy[name];
      return copy;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    clearError(name);
  };

useEffect(() => {
  if (previewInvoiceList?.providerId?._id) {
    qrCode(previewInvoiceList.providerId._id);
  }
}, [previewInvoiceList]);


  useEffect(() => {
    if (userData?.token) {
      getClientList();
      teamMembers();
      servicesList();
      getBranchList();
      // offerListInvoice()
      currencyLis()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
  if (userData?.token) getInvoiceData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [page, applyFilterKey]);

  const getClientList = () => {
    const payload = { providerId: userData?.providerId, isActive: true, count: 1000, page: 1 };
    axios
      .post(clientListApi(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) setClientData(resp.data.data || []);
        else if (resp.data.code === statusCodes.tokenExpire) logOutFun();
      })
      .catch((err) => console.error("Error fetching clients:", err));
  };

  const servicesList = () => {
    axios
      .post(
        multipleServicesListApi(),
        { userId: userData?.userId, branchId: userData?.locationId },
        { headers: { Authorization: `Bearer ${userData?.token}` } }
      )
      .then((resp) => (resp.data.code === statusCodes.ok ? setServiceList(resp.data.data || []) : setServiceList([])))
      .catch((err) => {
        console.error("Error fetching services:", err);
        setServiceList([]);
      });
  };

  const getBranchList = () => {
    axios
      .post(
        branchListApi(),
        { userId: userData?.userId, isActive: true, isDeleted: false, page: 1, count: 100 },
        { headers: { Authorization: `Bearer ${userData?.token}` } }
      )
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          const branches = resp.data.data || [];
          setBranchData(branches);
          const defaultBranch = branches.find((b) => b._id === userData?.locationId);
          if (defaultBranch) setFormData((prev) => ({ ...prev, branchId: defaultBranch._id }));
        } else if (resp.data.code === statusCodes.tokenExpire) logOutFun();
      })
      .catch((err) => console.error("Error fetching branches:", err));
  };

  const teamMembers = () => {
    const payload = {
      userId: userData?.providerId,
      isActive: true,
      count: 100,
      isAccepted: "accepted",
      branchId: userData?.locationId,
    };
    axios
      .post(staffListApi(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } })
      .then((resp) => (resp.data.code === statusCodes.ok ? setTeamMember(resp.data.data || []) : setTeamMember([])))
      .catch((err) => {
        console.error("Error fetching team members:", err);
        setTeamMember([]);
      });
  };

  const offerListInvoice = async (serviceId) => {
    if (!serviceId) return;

    // cache check to avoid re-fetch
    if (offerMap?.[serviceId]?.length) return;

    const payload = {
      branchId: userData?.locationId,
      serviceId: serviceId
    };

    try {
      const resp = await axios.post(offerListInvoiceAPI(), payload, {
        headers: { Authorization: `Bearer ${userData?.token}` }
      });

      if (resp.data.code === statusCodes.ok) {
        setOfferMap((prev) => ({
          ...prev,
          [serviceId]: resp.data.data || [],
        }));
      } else {
        setOfferMap((prev) => ({
          ...prev,
          [serviceId]: [],
        }));
      }
    } catch (err) {
      console.error("Error fetching offers:", err);
      setOfferMap((prev) => ({
        ...prev,
        [serviceId]: [],
      }));
    }
  };

  const gstPreviewInvoice = (id) => {
    axios
      .post(gstPreviewInvoiceAPI(id), {}, { headers: null })
      .then((resp) => (resp.data.code === statusCodes.ok ? setpreviewInvoiceList(resp.data.data || []) : setpreviewInvoiceList([])))
      .catch((err) => {
        console.error("Error fetching preview invoice:", err);
        setpreviewInvoiceList([]);
      });
  };



const resendInvoiceAPI = async () => {
  if (!selectedInvoice?.refNumber) {
    toast.error("Invoice reference number not found.");
    return;
  }

  // use resendSendType (modal state), not selectedInvoice.sendType
  const sendTypePayload = (resendSendType || [])
    .filter((x) => x.isSelected)
    .map((x) => ({
      type: x.type,
      email: x.type === "EMAIL" ? (x.email || "") : null,
      isSelected: true,
    }));

  if (!sendTypePayload.length) {
    toast.error("Select at least one share option.");
    return;
  }

  // validate email if EMAIL selected
  const emailRow = (resendSendType || []).find((x) => x.type === "EMAIL");
  if (emailRow?.isSelected) {
    if (!String(emailRow.email || "").trim()) {
      toast.error("Email is required.");
      return;
    }
    if (!isValidEmail(emailRow.email)) {
      toast.error("Enter valid email.");
      return;
    }
  }

  const payload = {
    refNumber: selectedInvoice.refNumber,
    sendType: sendTypePayload,
  };

  setResendLoading(true);
  try {
    const resp = await axios.post(resendInvoice(), payload, {
      headers: { Authorization: `Bearer ${userData?.token}` },
    });

    if (resp.data.code === statusCodes.ok) {
      toast.success(resp.data.message || "Invoice re-sent successfully.");
      handleCloseInvoiceModal();
    } else if (resp.data.code === statusCodes.tokenExpire) {
      logOutFun();
    } else {
      toast.error(resp.data.message || "Failed to resend invoice.");
    }
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to resend invoice.");
  } finally {
    setResendLoading(false);
  }
};



const getInvoiceData = () => {
  // convert to start/end of day in UTC ISO format
  const startDateTimeISO = searchFilter?.startDate
    ? moment(searchFilter.startDate).startOf("day").utc()
    : null;

  const endDateTimeISO = searchFilter?.endDate
    ? moment(searchFilter.endDate).endOf("day").utc()
    : null;

  const payload = {
    page, 
    count: PER_PAGE,
    ...(searchFilter.searchText ? { searchText: searchFilter.searchText } : {}),
    ...(searchFilter.staffId ? { staffId: searchFilter.staffId } : {}),
    ...(searchFilter.branchId ? { branchId: searchFilter.branchId } : {}),
    ...(searchFilter.clientId ? { clientId: searchFilter.clientId } : {}),
    ...(startDateTimeISO ? { startDate: startDateTimeISO } : {}), // 
    ...(endDateTimeISO ? { endDate: endDateTimeISO } : {}),       // 
  };

  axios
    .post(getInvoiceList(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } })
    .then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setInvoiceList(resp.data.data || []);
        setCount(resp.data.totalCount);
        
      }
    })
    .catch((err) => {
      console.error("Error fetching invoices:", err);
      setInvoiceList([]);
    });
};

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());



  // const calculateOfferDiscount = (basePrice, offer) => {

  //   if (!offer || !offer.discountValue) {
  //     return {
  //       discountValuediscountAmount: 0,
  //       finalAmount: basePrice,
  //     };
  //   }

  //   let discountValue = 0;
  //   let fAmount = 0

  //   console.log(basePrice,"basePrice")
  //   console.log(offer.discountValue,"offer.discountValue")

  //   if (offer.discountType === "FLAT") {
  //     // Direct flat discount
  //     discountValue = Number(offer.discountValue || 0);
  //    fAmount = basePrice - discountValue

  //   } 
    
  //   else if (offer.discountType === "PERCENT") {
  //     const percentDiscount = (basePrice * Number(offer.discountValue || 0)) / 100;
      
  //     if (offer.maximumValue && percentDiscount > Number(offer.maximumValue)) {
  //       discountValue = Number(offer.maximumValue);
  //     } else {
  //       discountValue = percentDiscount;
  //     }

  //     fAmount = basePrice - discountValue
  //   }

  //   discountValue = Math.min(discountValue, basePrice);

  //   return {
  //     discountValue,
  //     finalAmount:fAmount ,
  //   };
  // };

const calculateOfferDiscount = (basePrice, offer) => {

    if (!offer || !offer.discountValue) {
      return {
        discountValue: 0,
        finalAmount: basePrice,
      };
    }

    let discountValue = 0;
    let fAmount = 0;

    if (offer.discountType === "FLAT") {
      // Cap flat discount to basePrice to avoid negative values
      discountValue = Math.min(Number(offer.discountValue || 0), basePrice);
      fAmount = basePrice - discountValue;
    } 
    
    else if (offer.discountType === "PERCENT") {
      const percentDiscount = (basePrice * Number(offer.discountValue || 0)) / 100;
      
      if (offer.maximumValue && percentDiscount > Number(offer.maximumValue)) {
        discountValue = Math.min(Number(offer.maximumValue), basePrice);
      } else {
        discountValue = Math.min(percentDiscount, basePrice);
      }

      fAmount = basePrice - discountValue;
    }

    // Ensure final amount is never negative
    fAmount = Math.max(0, fAmount);
    discountValue = Math.min(discountValue, basePrice);

    return {
      discountValue,
      finalAmount: fAmount,
    };
  };


  // const calculateServiceGST = (service) => {
  //   const gstPercent = Number(service?.gstPercent || 0) || 0;
  //   const gstStatus = service?.GST || "EXCLUDE";
  //   const entered = Number(service?.serviceAmount || 0) || 0;
  //   const divisor = 1 + gstPercent / 100;

  //   if (gstStatus === "INCLUDE") {
  //     const finalAmount = entered;
  //     const basePrice = divisor === 0 ? finalAmount : finalAmount / divisor;
  //     const gstValue = finalAmount - basePrice;

  //     // Apply offer discount to basePrice //
  //     let discountedBase = basePrice;

  //     let offerDiscount = 0;
  //     if (service.selectedOffer) {
  //       const discount = calculateOfferDiscount(basePrice, service.selectedOffer);
  //       discountedBase = discount.finalAmount;
  //       offerDiscount = discount.discountAmount;
  //     }

  //     const finalGst = (discountedBase * gstPercent) / 100;

  //     return {
  //       basePrice: discountedBase,
  //       gstValue: finalGst,
  //       gstPrice: finalGst,
  //       finalAmount: discountedBase + finalGst,
  //       offerDiscount,
  //       originalBasePrice: basePrice,
  //     };
  //     // Offer discount for INCLUDE //
  //   }

  //   let basePrice = entered;
  //   let originalBase = basePrice;
    
  //   // Apply offer discount to basePrice //
  //   let offerDiscount = 0;
  //   if (service.selectedOffer) {
  //     const discount = calculateOfferDiscount(basePrice, service.selectedOffer);
  //     basePrice = discount.finalAmount;
  //     offerDiscount = discount.discountAmount;
  //   }


  //   const gstValue = (basePrice * gstPercent) / 100;
  //   const finalAmount = basePrice + gstValue;

  //   console.log(gstValue, 'gstValue')
  //   console.log(finalAmount, 'finalAmount')

  //   return {
  //     basePrice,
  //     gstValue,
  //     gstPrice: gstValue,
  //     finalAmount,
  //     offerDiscount,
  //     originalBasePrice: originalBase,
  //   };
  // };




const calculateServiceGST = (service) => {
  const gstPercent = Number(service?.gstPercent || 0);
  const gstStatus = service?.GST || "EXCLUDE";
  const enteredAmount = Number(service?.serviceAmount || 0);
  let offerDiscount = 0;

  // =========================
  // GST INCLUDED CASE
  // =========================
  if (gstStatus === "INCLUDE") {
    let basePrice = 0;
    let gstValue = 0;
    let finalAmount = 0;
    let discountedTotal = enteredAmount;

    // NEW (original values)
    let originalBasePrice = 0;
    let originalGstPrice = 0;
    let originalFinalAmount = 0;

      // ORIGINAL calculation (no offer)
    originalFinalAmount = enteredAmount;
    originalBasePrice = (enteredAmount * 100) / (100 + gstPercent);
    originalGstPrice = originalFinalAmount - originalBasePrice;

    // Apply offer on TOTAL first
    if (service.selectedOffer) {
      const discount = calculateOfferDiscount(
        enteredAmount,
        service.selectedOffer
      );
      offerDiscount = discount.discountValue;
      discountedTotal = enteredAmount - offerDiscount;

      const gstper = gstPercent / 100;
      basePrice = discount.finalAmount / (1 + gstper);
      gstValue = discount.finalAmount - basePrice;
      finalAmount = discount.finalAmount;


    } else {
      basePrice = (enteredAmount * 100) / (100 + gstPercent);
      gstValue = enteredAmount - basePrice;
      finalAmount = enteredAmount;
    }


    return {
      basePrice,
      gstValue,
      gstPrice: gstValue,
      finalAmount,
      offerDiscount,
      // originalBasePrice: +(enteredAmount).toFixed(2),
      // ONLY ADDITION
      originalBasePrice: +originalBasePrice.toFixed(2),
      originalGstPrice: +originalGstPrice.toFixed(2),
      originalFinalAmount: +originalFinalAmount.toFixed(2),
    };
  }else{

    let basePrice = enteredAmount;
    const originalBase = basePrice;
  let gstValue = 0;
let finalAmount = 0;

   let originalBasePrice = originalBase;
    let originalGstPrice = +((originalBase * gstPercent) / 100).toFixed(2);
    let originalFinalAmount = +(originalBase + originalGstPrice).toFixed(2);

    // Apply offer on BASE
    if (service.selectedOffer) {


      gstValue = +((basePrice * gstPercent) / 100).toFixed(2);
      finalAmount = +(basePrice + gstValue).toFixed(2);

      

      const discount = calculateOfferDiscount(
        finalAmount,
        service.selectedOffer
      );
      offerDiscount = discount.discountValue;



      const gstper = gstPercent / 100;
      basePrice = discount.finalAmount / (1 + gstper);
      gstValue = discount.finalAmount - basePrice;
      finalAmount = discount.finalAmount;

    }else{
      gstValue = +((basePrice * gstPercent) / 100).toFixed(2);
      finalAmount = +(basePrice + gstValue).toFixed(2);
    }
  
  
    return {
      basePrice,
      gstValue,
      gstPrice: gstValue,
      finalAmount,
      offerDiscount,
      originalBasePrice: originalBase,
      //  ONLY ADDITION
      originalBasePrice: +originalBasePrice.toFixed(2),
      originalGstPrice: +originalGstPrice.toFixed(2),
      originalFinalAmount: +originalFinalAmount.toFixed(2),

    };
  }

};

  const validateInvoiceData = () => {
    const newErrors = {};

    // Client validations
    if (!formData.clientId && !String(formData.clientName || "").trim()) {
      newErrors.clientId = "Client is required";
    }
    if (!formData.clientId) {
      if (!String(formData.clientName || "").trim()) newErrors.clientName = "Client name is required";
      if (!String(formData.mobileNo || "").trim()) newErrors.mobileNo = "Client phone is required";
    }
if (formData.startDateTime && formData.endDateTime) {
  const start = new Date(formData.startDateTime);
  const end = new Date(formData.endDateTime);
  if (end < start) {
    newErrors.endDateTime = "End date & time should be greater than start date & time";
  }
}
    if (!formData.branchId) newErrors.branchId = "Branch is required";
    if (!formData.startDateTime) newErrors.startDateTime = "Start date & time is required";
    if (!formData.endDateTime) newErrors.endDateTime = "End date & time is required";

    if (!formData.paymentMode) {
  newErrors.paymentMode = "Payment mode is required";
}

// Payment type validation - required only when ONLINE is selected
if (formData.paymentMode === "ONLINE" && !formData.paymentType) {
  newErrors.paymentType = "Payment type is required for online payments";
}

    // Send type validation (at least one selected)
    const selectedTypes = (formData.sendType || []).filter((x) => x.isSelected);
    if (selectedTypes.length === 0) newErrors.sendType = "Select at least one share option";

    // Email required only if EMAIL selected
    const emailRow = (formData.sendType || []).find((x) => x.type === "EMAIL");
    if (emailRow?.isSelected) {
      if (!String(emailRow.email || "").trim()) newErrors.email = "Email is required";
      else if (!isValidEmail(emailRow.email)) newErrors.email = "Enter valid email";
    }

    // Services required
    if (!formData.services || formData.services.length === 0) {
      newErrors.services = "At least one service must be selected";
      setErrors(newErrors);
      return false;
    }

    // Staff required
    const staffMap = {};
    (formData.services || []).forEach((s) => {
      if (!s.staffId) staffMap[s.serviceId] = "Team is required";
    });
    if (Object.keys(staffMap).length) newErrors.serviceStaffMap = staffMap;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  
// const generateBillInvoice = async () => {
//   if (!validateInvoiceData()) {
//     toast.error("Please fill all required fields");
//     return false;
//   }

//   const servicesPayload = (formData.services || [])
//     .filter((s) => s.serviceId)
//     .map((s) => {
//       const calc = calculateServiceGST(s);

//       const payload = {
//         serviceId: s.serviceId,
//         staffId: s.staffId,
//         serviceAmount: parseFloat((s.serviceAmount || 0).toFixed(2)),
//         basePrice: parseFloat((calc.basePrice || 0).toFixed(2)),
//         gstPrice: parseFloat((calc.gstPrice || 0).toFixed(2)),
//         finalAmount: parseFloat((calc.finalAmount || 0).toFixed(2)),
//         GST: s.GST || "EXCLUDE",
//         gstValue: parseFloat((s.gstPercent || 0).toFixed(2)),
//       };
//       if (s.selectedOffer && calc.offerDiscount > 0) {
//   payload.offer = {
//     offerId: s.selectedOffer._id,
//     Amount: parseFloat((calc.originalBasePrice || 0).toFixed(2)),
//     finalAmount: parseFloat((calc.basePrice || 0).toFixed(2)),
//     serviceName: s.serviceName || "",
//     offerName: s.selectedOffer.name || "",
//     discountAmount: parseFloat((calc.offerDiscount || 0).toFixed(2)),
//   };
// } else {
//   // ADD THIS BLOCK → always send offer even if not selected
//   payload.offer = {
//     offerId: null,
//     Amount: null,
//     finalAmount: null,
//     serviceName: null,
//     offerName: null,
//     discountAmount: null,
//   };
// }

//       return payload;
//     });

//   const subTotal = servicesPayload.reduce((sum, s) => sum + parseFloat(s.basePrice || 0), 0);
//   const totalGst = servicesPayload.reduce((sum, s) => sum + parseFloat(s.gstPrice || 0), 0);
//   const totalAmount = servicesPayload.reduce((sum, s) => sum + parseFloat(s.finalAmount || 0), 0);

//   const sendTypePayload = (formData.sendType || [])
//     .filter((x) => x.isSelected)
//     .map((x) => ({
//       type: x.type,
//       email: x.type === "EMAIL" ? (x.email || "") : null,
//       isSelected: true,
//     }));

//   const payload = {
//     startDateTime: moment(formData?.startDateTime).utc(),
//     endDateTime: moment(formData?.endDateTime).utc(),
//     timezone: formData?.timezone || timeZone,
//     branchId: formData?.branchId || null,
//     services: servicesPayload,
//     subTotal: parseFloat(subTotal.toFixed(2)),
//     totalGst: parseFloat(totalGst.toFixed(2)),
//     totalAmount: parseFloat(totalAmount.toFixed(2)),
//     createdby_id: formData?.createdby_id || userData?.userId,
//     clientId: formData?.clientId || null,
//     providerId: formData?.providerId || userData?.providerId,
//     visitType: "INOFFICE",
//     clientName: formData.clientName || null,
//     mobileNo: formData.mobileNo || null,
//     sendType: sendTypePayload,
//     additionalOffer: {
//       discountPrice: parseFloat(formData?.additionalOffer?.discountPrice || 0),
//       discount: parseFloat(formData?.additionalOffer?.discount || 0),
//       discountType: formData?.additionalOffer?.discountType || null,
//     },
//   };

//   setFormData((prev) => ({
//     ...prev,
//     subTotal: parseFloat(subTotal.toFixed(2)),
//     totalGst: parseFloat(totalGst.toFixed(2)),
//     totalAmount: parseFloat(totalAmount.toFixed(2)),
//   }));

//   setSpinner(true);
//   try {
//     const resp = await axios.post(gstGenerateInvoice(), payload, {
//       headers: { Authorization: `Bearer ${userData?.token}` },
//     });

//     if (resp.data.code === statusCodes.ok) {
//       toast.success(resp.data.message || "Invoice generated successfully!");
//       resetForm();
//       return true;
//     }

//     if (resp.data.code === statusCodes.tokenExpire) {
//       logOutFun();
//       return false;
//     }

//     toast.error(resp.data.message || "Failed to generate invoice");
//     return false;
//   } catch (error) {
//     toast.error(
//       error.response?.data?.message ||
//       commonMessage.networkError ||
//       "Failed to generate invoice"
//     );
//     return false;
//   } finally {
//     setSpinner(false);
//   }
// };


const generateBillInvoice = async () => {
  if (!validateInvoiceData()) {
    toast.error("Please fill all required fields");
    return false;
  }

  // Check if additional discount is applied
  const hasAdditionalDiscount = formData?.additionalOffer?.discount > 0;

  const servicesPayload = (formData.services || [])
    .filter((s) => s.serviceId)
    .map((s) => {
      const calc = calculateServiceGST(s);

      // Use additional discount values if they exist, otherwise use regular values
      const finalBasePrice = hasAdditionalDiscount && s.additionalBasePrice 
        ? s.additionalBasePrice 
        : calc.basePrice;
      
      const finalGstPrice = hasAdditionalDiscount && s.additionalGstValue 
        ? s.additionalGstValue 
        : calc.gstPrice;
      
      const finalAmount = hasAdditionalDiscount && s.additionalFinalAmount 
        ? s.additionalFinalAmount 
        : calc.finalAmount;

      // before prices

      // const useOriginalBefore =
      //   !hasAdditionalDiscount || !!s.selectedOffer;

      // const beforeBase = useOriginalBefore
      //   ? calc.originalBasePrice
      //   : calc.basePrice;

      // const beforeGst = useOriginalBefore
      //   ? calc.originalGstPrice
      //   : calc.gstPrice;

      // const beforeFinal = useOriginalBefore
      //   ? calc.originalFinalAmount
      //   : calc.finalAmount;

      let beforeBase, beforeGst, beforeFinal;

if (hasAdditionalDiscount) {
  // BEFORE = price after offer
  beforeBase  = calc.basePrice;
  beforeGst   = calc.gstPrice;
  beforeFinal = calc.finalAmount;

} else {
  // BEFORE = original price
  beforeBase  = calc.originalBasePrice;
  beforeGst   = calc.originalGstPrice;
  beforeFinal = calc.originalFinalAmount;


}

      const payload = {
        serviceId: s.serviceId,
        staffId: s.staffId,
        serviceAmount: parseFloat((s.serviceAmount || 0).toFixed(2)),
        basePrice: parseFloat((finalBasePrice || 0).toFixed(2)),
        gstPrice: parseFloat((finalGstPrice || 0).toFixed(2)),
        finalAmount: parseFloat((finalAmount || 0).toFixed(2)),
        // beforeDiscountBasePrice: parseFloat((calc.basePrice || 0).toFixed(2)),
        // beforeDiscountGstPrice:  parseFloat((calc.gstPrice || 0).toFixed(2)),
        // beforeDiscountFinalAmount:  parseFloat((calc.finalAmount || 0).toFixed(2)),
        beforeDiscountBasePrice: parseFloat((beforeBase || 0).toFixed(2)),
        beforeDiscountGstPrice: parseFloat((beforeGst || 0).toFixed(2)),
        beforeDiscountFinalAmount: parseFloat((beforeFinal || 0).toFixed(2)),
        GST: s.GST || "EXCLUDE",
        gstValue: parseFloat((s.gstPercent || 0).toFixed(2)),
      };

      if (s.selectedOffer && calc.offerDiscount > 0) {
        payload.offer = {
          offerId: s.selectedOffer._id,
          Amount: parseFloat((calc.originalBasePrice || 0).toFixed(2)),
          finalAmount: parseFloat((finalBasePrice || 0).toFixed(2)),
          serviceName: s.serviceName || "",
          offerName: s.selectedOffer.name || "",
          discountValue: parseFloat((calc.offerDiscount || 0).toFixed(2)),
        };
      } else {
        payload.offer = {
          offerId: null,
          Amount: null,
          finalAmount: null,
          serviceName: null,
          offerName: null,
          discountValue: null,
        };
      }

      return payload;
    });

  // Calculate totals from the payload (after additional discount)
  const subTotal = servicesPayload.reduce((sum, s) => sum + parseFloat(s.basePrice || 0), 0);
  const totalGst = servicesPayload.reduce((sum, s) => sum + parseFloat(s.gstPrice || 0), 0);
  const totalAmount = servicesPayload.reduce((sum, s) => sum + parseFloat(s.finalAmount || 0), 0);
  // before additional discount
  const beforeSubTotal = servicesPayload.reduce((sum, s) => sum + parseFloat(s.beforeDiscountBasePrice || 0), 0);
  const beforTotalGst = servicesPayload.reduce((sum, s) => sum + parseFloat(s.beforeDiscountGstPrice || 0), 0);
  const beforeTotalAmount = servicesPayload.reduce((sum, s) => sum + parseFloat(s.beforeDiscountFinalAmount || 0), 0);

  const sendTypePayload = (formData.sendType || [])
    .filter((x) => x.isSelected)
    .map((x) => ({
      type: x.type,
      email: x.type === "EMAIL" ? (x.email || "") : null,
      isSelected: true,
    }));

  const payload = {
    startDateTime: moment(formData?.startDateTime).utc(),
    endDateTime: moment(formData?.endDateTime).utc(),
    timezone: formData?.timezone || timeZone,
    branchId: formData?.branchId || null,
    services: servicesPayload,
    subTotal: parseFloat(subTotal.toFixed(2)),
    totalGst: parseFloat(totalGst.toFixed(2)),
    totalAmount: parseFloat(totalAmount.toFixed(2)),
    beforeSubTotal: parseFloat(beforeSubTotal.toFixed(2)),
    beforeTotalGst: parseFloat(beforTotalGst.toFixed(2)),
    beforeTotalAmount: parseFloat(beforeTotalAmount.toFixed(2)),
    createdby_id: formData?.createdby_id || userData?.userId,
    clientId: formData?.clientId || null,
    providerId: formData?.providerId || userData?.providerId,
    visitType: "INOFFICE",
    clientName: formData.clientName || null,
    mobileNo: formData.mobileNo || null,
    sendType: sendTypePayload,
    additionalOffer: {
      discountPrice: parseFloat(formData?.additionalOffer?.discountPrice || 0),
      discount: parseFloat(formData?.additionalOffer?.discount || 0),
      discountType: formData?.additionalOffer?.discountType || null,
    },
     paymentMode: formData.paymentMode || null,
  paymentType: formData.paymentMode === "ONLINE" ? formData.paymentType : null,
  };

  setFormData((prev) => ({
    ...prev,
    subTotal: parseFloat(subTotal.toFixed(2)),
    totalGst: parseFloat(totalGst.toFixed(2)),
    totalAmount: parseFloat(totalAmount.toFixed(2)),
  }));

  setSpinner(true);
  try {
    const resp = await axios.post(gstGenerateInvoice(), payload, {
      headers: { Authorization: `Bearer ${userData?.token}` },
    });

    if (resp.data.code === statusCodes.ok) {
      toast.success(resp.data.message || "Invoice generated successfully!");
      resetForm();
      getInvoiceData(); // Refresh the invoice list
      return true;
    }

    if (resp.data.code === statusCodes.tokenExpire) {
      logOutFun();
      return false;
    }

    toast.error(resp.data.message || "Failed to generate invoice");
    return false;
  } catch (error) {
    toast.error(
      error.response?.data?.message ||
      commonMessage.networkError ||
      "Failed to generate invoice"
    );
    return false;
  } finally {
    setSpinner(false);
  }
};

    const qrCode = (providerId ) => {

        axios.post(qrCodeApi(), { userId: providerId  }).then((resp) => {
            setQrCodeData(resp.data)
        }).catch(() => { })
    }



  const resetForm = () => {
     const defaultBranchId = userData?.locationId || null;
    setFormData({
      startDateTime: "",
      endDateTime: "",
      timezone: timeZone,
      branchId: defaultBranchId,
      services: [],
      subTotal: 0,
      totalGst: 0,
      totalAmount: 0,
      createdby_id: userData?.userId || "",
      clientId: "",
      providerId: userData?.providerId || "",
      visitType: "",
      sendType: defaultSendTypes(),
      clientName: null,
      mobileNo: "",
      additionalOffer: {             
      discountPrice: 0,            
      discount: 0,                      
      discountType: null,    
      
    }, 
     paymentMode: null,
    paymentType: null,
    });
    setErrors({});
    setOfferMap({});
  };


      const currencyLis = () => {
          axios.post(currency(), { loggedInUserId: userData?.userId }).then((resp) => {
              if (resp.data.code === statusCodes.ok) {
                  setCurrencyName(resp.data.data.symbol)
              }
          }).catch(() => { })
      }


  return {
    data: {
      clientData,
      teamMember,
      serviceList,
      formData,
      visitType,
      timeZone,
      branchData,
      spinner,
      errors,
      invoiceList,
      PER_PAGE,
      page,
      count,
      previewInvoiceList,
      invoiceMod,
      selectedInvoice,
      resendLoading,
      searchFilter, 
      // offerList
      offerMap,
      qrCodeData,
      userData,
      currencyName,
    },
    method: {
      generateBillInvoice,
      setFormData,
      handleChange,
      resetForm,
      validateInvoiceData,
      setErrors,
      calculateServiceGST,
      clearError,
      setPage,
      gstPreviewInvoice,
      handleCloseInvoiceModal,
      handleOpenInvoiceModal,
      resendInvoiceAPI,
        isSendSelected,
    selectedEmail,
    setResendSendType,
          setSearchFilter, // 
      handleFilterChange, // 
      applySearchFilter, // 
      resetSearchFilter, // 
      offerListInvoice,
      calculateOfferDiscount,
      setSpinner,
    },
  };
};

export default useBillInvoice;
